<template>
  <div class="contents">
    <div class="left">
      <emergency-left/>
    </div>
    <plan />
  </div>
</template>
<script>

export default {
  components: {
    emergencyLeft: () => import('./emergencyLeft/index'),
    plan: () => import('./plan/index'),
  },
  mounted() {}
};
</script>

<style scoped lang="less">
.contents{
  height: 100%;
  // width: 100%;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  .left{
    // width: calc(100% - 539px);
    width: 62%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/emergencyHandle/index.vue